import driver from './driver'
import vehicle from './vehicle'
import credential from './credential'
import blackList from './black-list'

export default {
  name: 'Transport',
  path: 'transport',
  meta: {
    label: 'transport',
    auth: 'transport'
  },
  component: {
    name: 'transport',
    render(c) {
      return c('router-view')
    }
  },
  children: [driver, vehicle, credential, blackList]
}
